

import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";
import { Database } from "@/integrations/supabase/types";

export type FixedJob = Database['public']['Views']['fixed_job_view']['Row'];

export const useFixedJobSearch = (teacherCode?: string) => {
  const [fixedJobs, setFixedJobs] = useState<FixedJob[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!teacherCode) {
      setFixedJobs([]);
      return;
    }

    const fetchJobs = async () => {
      setIsLoading(true);
      try {
        const { data, error } = await supabase
          .from("fixed_job_view")
          .select("*")
          .eq("teacher_code", teacherCode)
          .order("start_at", { ascending: true })
          .limit(10);
 
  
        if (error) {
          console.error("Error fetching fixed jobs:", error);
          toast({
            title: "Error",
            description: "Could not fetch fixed job data. Please try again.",
            variant: "destructive",
          });
          return;
        }
  
        setFixedJobs(data || []);
      } catch (error) {
        console.error("Error in API request:", error);
        toast({
          title: "Error",
          description: "Connection error. Please check your network.",
          variant: "destructive",
        });
        setFixedJobs([]);
      } finally {
        setIsLoading(false);
      }
    };
  
    fetchJobs();
  }, [teacherCode]);

  return {
    fixedJobs,
    isLoading
  };
};

